import { SVGProps } from 'react';

const CrossCircleFill: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12ZM14.2974 8.71598C14.5699 8.44352 15.0116 8.44352 15.2841 8.71598C15.5565 8.98844 15.5565 9.43018 15.2841 9.70264L12.9867 12L15.2841 14.2974C15.5565 14.5698 15.5565 15.0116 15.2841 15.284C15.0116 15.5565 14.5699 15.5565 14.2974 15.284L12 12.9867L9.70267 15.284C9.43022 15.5565 8.98847 15.5565 8.71601 15.284C8.44356 15.0116 8.44356 14.5698 8.71601 14.2974L11.0134 12L8.71601 9.70264C8.44356 9.43018 8.44356 8.98844 8.71601 8.71598C8.98847 8.44352 9.43022 8.44352 9.70267 8.71598L12 11.0133L14.2974 8.71598Z"
      fill="#268038"
    />
  </svg>
);

export default CrossCircleFill;
